import { inject, InjectionKey, provide, Ref, ref, nextTick } from 'vue'
import { AxiosError } from 'axios'
import { scrollToElement } from '@/utils/scroll-to'

interface ValidationError {
  error: string
  message: string
}

const useValidation = <T>(key: InjectionKey<T>) => {
  const provideValidation = function () {
    const errors: any = ref({})

    provide(key, errors)

    return errors
  }

  const setValidationErrors = function (
    axiosError: AxiosError,
    errors: Ref<object>
  ) {
    if (axiosError.response !== undefined) {
      const respErrors: ValidationError = axiosError.response
        .data as ValidationError
      errors.value = {
        [respErrors.error]: respErrors.message,
        [respErrors.error.replace('.', '_')]: respErrors.message
      }
      nextTick(scrollToFirstError)
    }
    return errors.value
  }

  const scrollToFirstError = () => {
    scrollToElement('.el-form-item__error', true)
  }

  const validationErrors = function () {
    return inject(key)
  }

  return {
    provideValidation,
    setValidationErrors,
    validationErrors,
    scrollToFirstError
  }
}

export default useValidation
